import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const AdminPartsQuotes = lazy(() => import("@/pages/admin/AdminPartsQuotes"));

function AdminPartsQuotesRoute() {
  return (
    <Suspense fallback={<div className="min-h-screen bg-background" />}>
      <AdminPartsQuotes />
    </Suspense>
  );
}

export const Route = createFileRoute("/_adminLayout/admin/parts/quotes")({
  component: AdminPartsQuotesRoute,
  validateSearch: (search: Record<string, unknown>) => ({
    lead: typeof search['lead'] === "string" ? (search['lead'] as string) : undefined,
    id: typeof search['id'] === "string" ? (search['id'] as string) : undefined,
  }),
});
